import { apiUrl } from "../config";

function base64ToBytes(value) {
  if (!value) return null;
  try {
    const bin = atob(value);
    return Uint8Array.from(bin, (char) => char.charCodeAt(0));
  } catch {
    return null;
  }
}

export async function createWalletProof({ selector, accountId, signal } = {}) {
  const normalizedAccountId = String(accountId || "").trim();
  if (!selector || !normalizedAccountId) {
    throw new Error("Wallet is not connected");
  }

  const initRes = await fetch(apiUrl(`ref/auth/init?wallet=${encodeURIComponent(normalizedAccountId)}`), {
    method: "GET",
    signal,
  });
  if (!initRes.ok) {
    throw new Error(`auth init failed: ${initRes.status}`);
  }

  const initData = await initRes.json();
  const nonceBytes = base64ToBytes(initData?.nonce);
  if (!nonceBytes || nonceBytes.length !== 32) {
    throw new Error("invalid nonce");
  }

  const wallet = await selector.wallet();
  const signed = await wallet.signMessage({
    message: initData.message_to_sign,
    recipient: initData.recipient,
    nonce: nonceBytes,
    state: initData.state,
  });

  if (!signed?.signature || !signed?.publicKey) {
    throw new Error("wallet signMessage failed");
  }

  return {
    accountId: signed.accountId || normalizedAccountId,
    publicKey: signed.publicKey,
    signature: signed.signature,
    message: initData.message_to_sign,
    recipient: initData.recipient,
    nonce: initData.nonce,
    state: initData.state,
  };
}
